import { render, staticRenderFns } from "./FlagInputList.vue?vue&type=template&id=2c09211c&scoped=true&"
import script from "./FlagInputList.vue?vue&type=script&lang=js&"
export * from "./FlagInputList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c09211c",
  null
  
)

export default component.exports